import { render, staticRenderFns } from "./QrScan.vue?vue&type=template&id=2b7a114b&scoped=true&"
import script from "./QrScan.vue?vue&type=script&lang=js&"
export * from "./QrScan.vue?vue&type=script&lang=js&"
import style0 from "./QrScan.vue?vue&type=style&index=0&id=2b7a114b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a114b",
  null
  
)

export default component.exports